module.exports = __webpack_public_path__ + "static/media/logo_white.c0539a6f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/preference/logo_white.svg
// module id = 186
// module chunks = 0